import styled from 'styled-components';
import { colors } from "../../utils/colors";

export const Background = styled.div`
    position: relative;
    width: 100vw;
    min-height: 100vh;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px 60px;

    @media (max-width: 1200px) {
            padding: 100px 40px;
    }

    @media (max-width: 800px) {
            padding: 60px 20px;
    }
`;

export const RowWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    padding: 20px 0;

    @media (max-width: 1200px) {
        flex-direction: ${(props) => props.reverse ? 'column-reverse' : 'column'};
        padding: 0 0;
    }
`;

export const BenefitsTitle = styled.h1`
    color: ${colors.BLUE};
    font-family: 'Courgette', cursive;
    margin-bottom: 50px;
`;

export const ThirtyPercent = styled.div`
    display: flex;
    align-items: ${(props) => props.flexStart ? 'flex-start' : 'center'};;
    justify-content: center;
    flex-direction: column;
    width: 20%;

    @media (max-width: 1200px) {
        align-items: center;
        width: 90%;
    }
`;

export const SeventyPercent = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    width: 80%;

    @media (max-width: 1200px) {
        width: 90%;
        margin: 40px 0;
        align-items: center !important;
    }
`;

export const BenefitImg = styled.img`
    width: ${(props) => props.cost ? '60%' : props.savingSpace ? '80%' : props.environment ? '30%': '40%'};
    margin-bottom: 20px;

    @media (max-width: 1200px) {
        width: ${(props) => props.cost ? '55%' : props.savingSpace ? '50%' : props.environment ? '20%': '30%'};
    }
`;

export const GlassesImage = styled.img`
    width: 80%;
    max-width: 400px;

    @media (max-width: 1200px) {
        margin: 50px 0;
    }
`;

export const BenefitText = styled.p`
    color: ${colors.CREAM};
    text-align: ${(props) => props.right ? 'right' : 'left'};
    font-family: 'Markazi Text', serif;
    align-self: ${(props) => props.right ? 'flex-end' : 'flex-start'};

    @media (max-width: 1200px) {
        align-self: center !important;
        text-align: center !important;
    }
`;

export const SpeedImage = styled.img`
    width: 200px;
    margin-bottom: 20px;

    @media (max-width: 500px) {
        width: 120px;
    }
`;

export const SavingSpaceImage = styled.img`
    width: 380px;
    margin-bottom: 20px;

    @media (max-width: 500px) {
        width: 240px;
    }
`;

export const EnvironmentImage = styled.img`
    width: 420px;
    margin-bottom: 20px;

    @media (max-width: 500px) {
        width: 260px;
    }
`;
